import { useQuery } from "@tanstack/react-query";

import { captainQueryKeys } from "./query-keys";
import type { ConversationSummary } from "../types";

import { instance } from "@/lib/axios/instance";

export function useConversations(enabled = true, limit = 50) {
  return useQuery<ConversationSummary[]>({
    queryKey: captainQueryKeys.conversations(),
    queryFn: () =>
      instance
        .get<ConversationSummary[]>("/api/v2/captain/conversations", {
          params: { limit },
        })
        .then((res) => res.data),
    enabled,
  });
}
